<template>
  <header class="page-header">
    <div class="header-content">
      <div class="header-left">
        <i :class="icon" class="header-icon"></i>
        <div class="header-titles">
          <h1 class="page-title">{{ title }}</h1>
          <p v-if="subtitle" class="page-subtitle">{{ subtitle }}</p>
        </div>
      </div>
      <button v-if="showButton" @click="$emit('action')" class="btn-refresh" :class="{'icon-only': !buttonText}">
        <i :class="buttonIcon" v-if="buttonIcon"></i>
        <span v-if="buttonText">{{ buttonText }}</span>
      </button>
    </div>
  </header>
</template>

<script>
export default {
  name: 'PageHeader',
  props: {
    icon: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      default: ''
    },
    buttonText: {
      type: String,
      default: 'Actualizar'
    },
    buttonIcon: {
      type: String,
      default: 'ri-loop-right-line'
    },
    showButton: {
      type: Boolean,
      default: true
    }
  },
  emits: ['action']
}
</script>

<style scoped>
/* ============================================
   PAGE HEADER COMPONENT
   ============================================ */
.page-header {
  background: var(--theme-bg-secondary);
  border-bottom: 1px solid var(--theme-border-color);
  box-shadow: var(--theme-shadow-sm);
  position: sticky;
  top: 0px;
  z-index: 100;
}

.header-content {
  max-width: 1400px;
  margin: 0 auto;
  padding: 1rem 1.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 0.875rem;
  flex: 1;
  min-width: 0;
}

.header-icon {
  color: var(--app-primary-blue);
  font-size: 1.75rem;
  flex-shrink: 0;
}

.header-titles {
  min-width: 0;
  flex: 1;
}

.page-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--theme-text-primary);
  margin: 0;
  line-height: 1.2;
}

.page-subtitle {
  font-size: 0.875rem;
  color: var(--theme-text-secondary);
  margin: 0.25rem 0 0 0;
  font-weight: 500;
}

.btn-refresh {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: var(--app-primary-blue);
  color: white;
  border: none;
  padding: 0.625rem 1.25rem;
  border-radius: 8px;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: var(--theme-shadow-sm);
  white-space: nowrap;
}

.btn-refresh:hover {
  transform: translateY(-1px);
  box-shadow: var(--theme-shadow-md);
  background: #005a9e;
}

.btn-refresh.icon-only {
  width: 44px;
  height: 44px;
  padding: 0;
  justify-content: center;
  border-radius: 12px;
  background: var(--theme-hover-bg-light);
  color: var(--theme-nav-text);
  border: 1px solid var(--theme-border-color);
}

.btn-refresh.icon-only:hover {
  background: var(--theme-hover-bg);
}

.btn-refresh i {
  font-size: 1.125rem;
  transition: transform 0.3s ease;
}

.btn-refresh:hover i {
  transform: rotate(180deg);
}

/* ============================================
   RESPONSIVE
   ============================================ */
@media (max-width: 768px) {
  .header-content {
    flex-direction: column;
    align-items: stretch;
    padding: 0.5rem;
    gap: 0.5rem;
  }

  .btn-refresh {
    width: 100%;
    justify-content: center;
  }

  .page-subtitle {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

@media (max-width: 480px) {
  .page-title {
    font-size: 1.25rem;
  }

  .header-icon {
    font-size: 1.5rem;
  }
}
</style>
